import { useQuery } from "@tanstack/react-query";
import { getBusinessPatientOverview } from "apis";
import { useMyAccessProfileV2 } from "./get-my-access-profile";
import { usePackageBookingStore } from "@elixir/stores";

export const getPatientOverviewQueryKey = (patient_oid?: string) => {
  const keys = ["patient-overview"];
  if (patient_oid) {
    keys.push(patient_oid);
  }
  return keys;
};

const useGetPatientOverview = ({ patientId }: { patientId: string }) => {
  const { data: myAccessProfile } = useMyAccessProfileV2();
  const includeCompletedPackage = usePackageBookingStore(
    (state) => state.includeCompletedPackage
  );
  return useQuery(
    getPatientOverviewQueryKey(patientId),
    () =>
      getBusinessPatientOverview({
        patientId,
        business_id: myAccessProfile?.business?.id || "",
        includeCompletedPackage: includeCompletedPackage,
      }),
    {
      enabled: !!patientId && !!myAccessProfile,
    }
  );
};

export default useGetPatientOverview;
